<template>
  <div class="ln-user-account">
    <span class="form-title">当前账号:</span>
    <h2 class="number">
      {{ guestInfo.guestAccount || '请先登录' }}
    </h2>
    <div>
      <span class="form-title">账号密码</span>
      <h2 class="number">
        {{ guestInfo.guestPass }}
      </h2>
    </div>
    <Form ref="form">
      <div class="bottom">
        <Row class="login-row">
          <div style="font-size: 13px; text-align: center; margin-bottom: 10px">自行截图保存，账号密码永不丢失！</div>
          <Button class="login-btn" block type="info" native-type="button" @click="closeWindow"> 确定 </Button>
        </Row>
      </div>
    </Form>
    <van-icon style="position: absolute; right: 0; top: 0; right: 10px; top: 10px" name="cross" @click="closeWindow" />
  </div>
</template>

<script>
import { Form, Button, Row, Dialog } from 'vant';
import { mapState } from 'vuex';
import channelServer from '@/server/channelServer';
import server from '@/server';
import mixServer from '../server/mixServer';

export default {
  name: 'ln-user-account',
  components: { Form, Row, Button },
  data() {
    return {
      isShowPass: false,
    };
  },
  computed: {
    ...mapState(['user', 'guestInfo', 'guestLoginData', 'show_bind']),
    showUpass() {
      const passwd = this.user.passwd;
      return this.isShowPass ? passwd : passwd.replace(/./g, '*');
    },
  },
  created() {},
  mounted() {
    // console.log(this.user)
  },
  methods: {
    closeWindow() {
      // this.$store.commit('CLOSE');
      this.$store.commit('SET_ISCLOSEPWD', true);
      // channelServer.guestLogin();
      const guestData = JSON.parse(this.guestLoginData.info);
      if (guestData.is_bind == 0 && this.show_bind == 1) {
        this.$store.commit('SHOW', {
          name: 'BindPhone',
          params: guestData,
        });
      } else {
        // 融合登录
        if (guestData && guestData.force_cert_status == 0 && mixServer.isAntiAddiction == 1) {
          this.$store.commit('SHOW', {
            name: 'CertFront',
            params: { cert_url: guestData.real_name_cert, cert_msg: guestData.cert_msg },
          });
        } else {
          mixServer.login(this.guestLoginData)
        }
      }
      // console.log(this.guestLoginData);
      // server.autoLogin();
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/css/var.scss';
.ln-user-account {
  .number {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $theme-color;
    margin: 5px 15px;
    font-size: 20px;
    .eye-icon {
      color: #969799;
    }
  }
}
</style>
